import { useContext } from "react";
import { ThemeContext } from "../../context/theme/ThemeContext";
import {
  cumstomerImg1,
  cumstomerImg2,
  cumstomerImg3,
  cumstomerImg4,
  cumstomerImg5,
  cumstomerImg6,
  cumstomerImg7,
  cumstomerImg8,
  cumstomerImg9,
  cumstomerImg10,
  cumstomerImg11,
  cumstomerImg12,
  cumstomerImg13,
  cumstomerImg14,
  cumstomerImg15,
  cumstomerImg16,
  cumstomerImg17,
  cumstomerImg18,
  cumstomerImg19,
  cumstomerImg20,
  cumstomerImg21,
  cumstomerImg22,
  cumstomerImg23,
  cumstomerImg24,
  cumstomerImg25,
  cumstomerImg26,
  cumstomerImg27,
  cumstomerImg28,
  cumstomerImg29,
  cumstomerImg30,
  cumstomerImg31,
  cumstomerImg32,
  cumstomerImg33,
  cumstomerImg34,
  cumstomerImg35,
  cumstomerImg36,
  cumstomerImg37,
  cumstomerImg38,
  cumstomerImg39,
  cumstomerImg40,
  cumstomerImg41,
  cumstomerImg42,
  cumstomerImg43,
  cumstomerImg44,
  cumstomerImg45,
  cumstomerImg46,
  cumstomerImg47,
  cumstomerImg48,
  cumstomerImg49,
  cumstomerImg1Dark,
  cumstomerImg3Dark,
  cumstomerImg4Dark,
  cumstomerImg5Dark,
  cumstomerImg6Dark,
  cumstomerImg8Dark,
  cumstomerImg12Dark,
  cumstomerImg18Dark,
  cumstomerImg19Dark,
  cumstomerImg22Dark,
  cumstomerImg23Dark,
  cumstomerImg27Dark,
  cumstomerImg28Dark,
  cumstomerImg33Dark,
  cumstomerImg44Dark,
  cumstomerImg45Dark,
  cumstomerImg49Dark,
} from "../../images";

// Map of regular images to their dark versions
const imageToDarkMap = new Map([
  [cumstomerImg1, cumstomerImg1Dark],
  [cumstomerImg3, cumstomerImg3Dark],
  [cumstomerImg4, cumstomerImg4Dark],
  [cumstomerImg5, cumstomerImg5Dark],
  [cumstomerImg6, cumstomerImg6Dark],
  [cumstomerImg8, cumstomerImg8Dark],
  [cumstomerImg12, cumstomerImg12Dark],
  [cumstomerImg18, cumstomerImg18Dark],
  [cumstomerImg19, cumstomerImg19Dark],
  [cumstomerImg22, cumstomerImg22Dark],
  [cumstomerImg23, cumstomerImg23Dark],
  [cumstomerImg27, cumstomerImg27Dark],
  [cumstomerImg28, cumstomerImg28Dark],
  [cumstomerImg33, cumstomerImg33Dark],
  [cumstomerImg44, cumstomerImg44Dark],
  [cumstomerImg45, cumstomerImg45Dark],
  [cumstomerImg49, cumstomerImg49Dark],
]);

/**
 * Hook to get theme-aware image
 * Returns dark version if theme is dark and dark version exists, otherwise returns regular image
 * @param {object} regularImage - The regular image import
 * @returns {object} - The appropriate image based on theme
 */
export const useThemeImage = (regularImage) => {
  const { themeColor } = useContext(ThemeContext);
  const isDarkTheme = themeColor === "#181818";

  // If not dark theme, return regular image
  if (!isDarkTheme) {
    return regularImage;
  }

  // If dark theme, check if dark version exists
  const darkImage = imageToDarkMap.get(regularImage);
  
  // Return dark version if available, otherwise return regular image
  return darkImage || regularImage;
};

